import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import { useOrderCalculationSideCart } from '@/lib/hooks/services/useOrderCalculationSideCart'
import {
  generateCartEventData,
  getCartItemsCount,
} from '@/lib/services/mixpanel/helpers/generateCartEventData'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect } from 'react'
import { Drawer, DrawerContent } from '../_ui/Drawer'
import CartSheetContent from './_components/CartSheetContent'
import CartSheetFooter from './_components/CartSheetFooter'
import CartSheetHeader from './_components/CartSheetHeader'

const CartSheet = () => {
  const {
    setApp,
    app: { isCartOpen, marketExceptions },
    cart,
    user: { customerType },
  } = useGlobalStore()

  const { isLoadingOrderCalculation, orderCalculationError } =
    useOrderCalculationSideCart()

  const { gtm } = useGTM()
  const currentItems = [...cart.otp, ...cart.subscribe]

  useEffect(() => {
    if (isCartOpen) {
      gtm.viewCart(currentItems)

      mixpanelService
        .trackEvent(MixpanelEvent.VIEW_CART, {
          cart: generateCartEventData(
            cart,
            marketExceptions?.currencyCode || 'USD',
            customerType,
          ),
          item_count: getCartItemsCount(cart),
        })
        .catch(() => {})
    }
  }, [isCartOpen])

  return (
    <Drawer
      direction="right"
      open={isCartOpen}
      onOpenChange={() => setApp({ isCartOpen: false })}
    >
      <DrawerContent className="w-full px-0 sm:max-w-xl sm:px-5">
        <div className="relative flex h-full flex-col pt-8">
          <CartSheetHeader />
          <CartSheetContent
            isLoadingOrderCalculation={isLoadingOrderCalculation}
            orderCalculationError={orderCalculationError}
          />
          <CartSheetFooter />
        </div>
      </DrawerContent>
    </Drawer>
  )
}

export default CartSheet
